<template>
	<div>
		<div class="sticky-container">
			<table class="table table-xs table-bordered table-hover" v-if="loadedconfig && loadedconfig.cols">
				<thead>
					<tr>
						<template v-if="!loadedconfig.teacher">
							<th></th>
							<th></th>
							<th></th>
                            <th></th>
							<th></th>
						</template>
						<th></th>
						<th v-for="(datapoint, dIndex) in loadedconfig.cols" v-bind:key="dIndex" class="tilt" @click="selectedColumn = dIndex" v-bind:class="{ 'table-secondary': selectedColumn === dIndex }">
							<div>{{datapoint.caption}}</div>
						</th>
						<!--
						<template v-for="(row, rowIndex) in reportconfig.grid">
							<template v-for="(col, colIndex) in row">
								<th v-for="(datapoint, dIndex) in col.fields" v-bind:key="rowIndex + '_' + colIndex + '_' + dIndex">
									{{datapoint.caption}}
								</th>
							</template>
						</template>
						-->
					</tr>
                    <tr>
						<template v-if="!loadedconfig.teacher">
							<th></th>
							<th></th>
							<th></th>
                            <th></th>
							<th></th>
						</template>
						<th style="text-align: right">{{$t('targets')}}</th>
						<th v-for="(datapoint, dIndex) in loadedconfig.cols" v-bind:key="dIndex" class="text-right" >
							<!--
							<template v-if="(datapoint.reportdataelement in targets) && (programme in targets[datapoint.reportdataelement])">
								Prg.
							</template>
							<template v-if="(datapoint.reportdataelement in targets) && (programme in targets[datapoint.reportdataelement] && (year in targets[datapoint.reportdataelement][programme]))">
								Yr.
							</template>
							<template v-if="(datapoint.reportdataelement in targets) && (programme in targets[datapoint.reportdataelement] && (year in targets[datapoint.reportdataelement][programme])) && (term in targets[datapoint.reportdataelement][programme][year])">
								Tm.
							</template>
							{{datapoint.reportdataelementproperty}}
							-->
							<template v-if="(datapoint.reportdataelement in currenttargets) && (datapoint.reportdataelementproperty in currenttargets[datapoint.reportdataelement])">
								{{currenttargets[datapoint.reportdataelement][datapoint.reportdataelementproperty]}}
							</template>
						</th>
						<!--
						<template v-for="(row, rowIndex) in reportconfig.grid">
							<template v-for="(col, colIndex) in row">
								<th v-for="(datapoint, dIndex) in col.fields" v-bind:key="rowIndex + '_' + colIndex + '_' + dIndex">
									{{datapoint.caption}}
								</th>
							</template>
						</template>
						-->
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in users" :key="user.id" :class="{ 'table-secondary': selectedRow === user.id }" @click="selectedRow = user.id">
						<td @click="viewIndivudalReport(user)">{{user.displayName}}</td>
						<template v-if="!loadedconfig.teacher">
                            <td>{{ user.studentid }}</td>
							<td>{{ $config.getProgrammeNameById(user.programme) }}</td>
							<td>{{ $config.getUserYearStr(user) }}</td>
							<td>{{ $config.getGroupNameById(user.group) }}</td>
							<td>{{ $config.getFirmNameById(user.firm) }}</td>
						</template>
						<template v-for="(datapoint, dIndex) in loadedconfig.cols">
							<template v-if="(user.id in userreportdata) && (datapoint.reportdataelement in userreportdata[user.id]) && (datapoint.reportdataelementproperty in userreportdata[user.id][datapoint.reportdataelement]) && userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty] !== null">
								<td :key="dIndex" class="text-right" :class="getCellClass(user, datapoint,dIndex)">
									{{userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty]}}
								</td>
							</template>
							<template v-else>
								<td :key="dIndex" class="skeleton">-</td>
							</template>
						</template>
						<!--
						<template v-for="(row, rowIndex) in reportconfig.grid">
							<template v-for="(col, colIndex) in row">
								<td v-for="(datapoint, dIndex) in col.fields" v-bind:key="rowIndex + '_' + colIndex + '_' + dIndex">
									{{datapoint.caption}}
								</td>
							</template>
						</template>
						-->
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		reportid: String,
		filters: Object ,
		loadedconfig: Object
	},
	components: {
	},
	data() {
		return {
			reportdata: {},
			userreportdata: {},
			targets: {},
			currenttargets: {},
			users: [],
			programme: null ,
			year: null ,
			term: null,
			selectedRow : null,
			selectedColumn : null,
		};
	},
	mounted() {
		if(this.loadedconfig) {
			if(this.loadedconfig.teacher){
				this.getTeachers();
			} else {
				this.getStudents();
			}
			this.getReportData();
		}
	},
	watch: {
		loadedconfig: function(){
			this.refreshReportData()
		},
		users: function() {
			if(this.users) {
				this.getReportData();
			}
		}
	},
	methods: {
		refreshReportData() {
			if(this.loadedconfig){
				this.reportdata = {};
				if(this.loadedconfig.teacher){
					this.getTeachers();
				} else {
					this.getStudents();
				}
				this.getReportData();
			}
		},
		getColClass(col){
			return 'col-md-' + col.width;
		},
		getStudents() {
			this.users = [];
			var filters = this.getCleanedFilters();
			this.$users.getStudents.call(this).then(users => {
				users.forEach((user) => {
					if(!filters.programme || filters.programme==user.programme){
						if(!filters.year || filters.year==user.year){
							if(!filters.group || filters.group==user.group){
								if(!filters.firm || filters.firm==user.firm){
									this.users.push(user);
								}
							}
						}
					}
				});
				//this.users = users;
			});
		},
		getTeachers() {
			this.$users.getTeachers.call(this).then(teachers => {
				this.users = teachers;
			});
		},
		getReportData() {
			//this.userreportdata = {};
			for(var ri in this.loadedconfig.cols){
				if(!(this.loadedconfig.cols[ri].reportdataelement in this.targets)){
					this.$set(this.targets , this.loadedconfig.cols[ri].reportdataelement , {});
				}
			}
			for(var si in this.users){
				this.$set(this.userreportdata , this.users[si].id , {});
				for(ri in this.loadedconfig.cols){
					if(!(this.loadedconfig.cols[ri].reportdataelement in this.userreportdata[this.users[si].id])){
						this.$set(this.userreportdata[this.users[si].id] , this.loadedconfig.cols[ri].reportdataelement , {});
					}
					this.$set(this.userreportdata[this.users[si].id][this.loadedconfig.cols[ri].reportdataelement] , this.loadedconfig.cols[ri].reportdataelementproperty , null);
					this.getReportDataValue(this.loadedconfig.cols[ri].reportdataelement);
				}
			}
		} ,
		getReportDataValue(reportdataelement){
			var value = 0;
			if(!(reportdataelement in this.reportdata)){
				this.getReportDataElement(reportdataelement).then((json) => {
					if (json.status === "SUCCESS") {
						if('retry' in json){
							// We need to retry this latert
							var self = this;
							window.setTimeout(function(){
								delete self.reportdata[reportdataelement];
								self.getReportDataValue(reportdataelement);
							} , 2000);
						} else {
							this.targets[reportdataelement] = json.result.values.targets;
							this.setCurrentTargets(reportdataelement);
							this.setuserValues(reportdataelement , json.result);
						}
					}
				});
			}
			return value
		},
		refreshTargets() {
			for(var ri in this.loadedconfig.cols){
				this.setCurrentTargets(this.loadedconfig.cols[ri].reportdataelement);
			}
		},
		setCurrentTargets(reportdataelement){
			this.$set(this.currenttargets , reportdataelement , {});
			if(
				(reportdataelement in this.targets) &&
				(this.programme in this.targets[reportdataelement]) &&
				(this.year in this.targets[reportdataelement][this.programme]) &&
				(this.term in this.targets[reportdataelement][this.programme][this.year])
			) {
				this.$set(this.currenttargets , reportdataelement , this.targets[reportdataelement][this.programme][this.year][this.term]);
			}

		},
		setuserValues(reportdataelement, resultset){
			for(var si in this.users){
				if(this.users[si].id in resultset.values.results){
					for(var key in this.userreportdata[this.users[si].id][reportdataelement]){
						if(key in resultset.values.results[this.users[si].id] && resultset.values.results[this.users[si].id][key] != '-' && resultset.values.results[this.users[si].id][key] !== null){
							if(resultset.values.datasource == 'competencytestpass'){
								// Work out whether to show a date or an integer
								if(resultset.values.results[this.users[si].id][key] > 0){
									this.userreportdata[this.users[si].id][reportdataelement][key] = this.$datetime.timestampToDate(resultset.values.results[this.users[si].id][key]);
								} else {
									this.userreportdata[this.users[si].id][reportdataelement][key] = 0;
								}
							} else {
								// Work out whether to show a date or an integer
								if(resultset.values.results[this.users[si].id][key] > 1000000){
									this.userreportdata[this.users[si].id][reportdataelement][key] = this.$datetime.timestampToDate(resultset.values.results[this.users[si].id][key]);
								} else {
									// This is to catch a specific vue related issue with the "some" key in "BDA Case Mix"
									if(typeof(resultset.values.results[this.users[si].id][key]) == 'function'){
										this.userreportdata[this.users[si].id][reportdataelement][key] = 0;
									} else {
										this.userreportdata[this.users[si].id][reportdataelement][key] = resultset.values.results[this.users[si].id][key];
									}
								}
							}
						} else {
							this.userreportdata[this.users[si].id][reportdataelement][key] = 0;
						}
					}
				} else {
					for(var vkey in this.userreportdata[this.users[si].id][reportdataelement]){
						this.userreportdata[this.users[si].id][reportdataelement][vkey] = 0;
					}
				}
			}
		},
		getCleanedFilters() {
			var filters = JSON.parse(JSON.stringify(this.filters));
			if(this.filters.programme){
				filters.programme = this.filters.programme.Id;
			}
			/*
			if(filters.group){
				filters.programme = filters.group.Id;
			}
			if(filters.firm){
				filters.programme = filters.firm.Id;
			}
			*/
			return filters;
		},
		getReportDataElement(reportdataelement) {
			const data = {
				filters: this.getCleanedFilters()
			};
			this.reportdata[reportdataelement] = this.$cfetch(`${this.$settings.APIBaseURL}/reporting/dataelement/${reportdataelement}`, {
				cache: false,
				method: 'post',
				data
			});
			return this.reportdata[reportdataelement];
		},
		getCellClass(user, datapoint,dIndex) {
			if(datapoint.type == 'datepassed'){
				if((user.id in this.userreportdata) && (datapoint.reportdataelement in this.userreportdata[user.id]) && (datapoint.reportdataelementproperty in this.userreportdata[user.id][datapoint.reportdataelement]) && this.userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty] != 0){
					return 'bg-fourth-quartile';
				}
				return 'bg-first-quartile';
			} else {
				if((datapoint.reportdataelement in this.currenttargets) && (datapoint.reportdataelementproperty in this.currenttargets[datapoint.reportdataelement])){
					if((user.id in this.userreportdata) && (datapoint.reportdataelement in this.userreportdata[user.id]) && (datapoint.reportdataelementproperty in this.userreportdata[user.id][datapoint.reportdataelement]) && this.userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty] !== null){
						if(Number(this.userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty]) >= Number(this.currenttargets[datapoint.reportdataelement][datapoint.reportdataelementproperty])){
							return 'bg-fourth-quartile';
						} else if(Number(this.userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty]) / Number(this.currenttargets[datapoint.reportdataelement][datapoint.reportdataelementproperty]) >= .75){
							return 'bg-third-quartile';
						} else if(Number(this.userreportdata[user.id][datapoint.reportdataelement][datapoint.reportdataelementproperty]) / Number(this.currenttargets[datapoint.reportdataelement][datapoint.reportdataelementproperty]) >= .5){
							return 'bg-second-quartile';
						}
					}
					return 'bg-first-quartile';
				}
			}
			if (this.selectedColumn === dIndex){
				return 'table-secondary';
			}
			return '';
		},
		viewIndivudalReport(user) {
			this.$router.push(`/reports/report/${this.reportid}/${user.id}`);
		}
	},
	computed: {
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		}
	}
};
</script>
